var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-card"},[_c('div',[_vm._t("body",[_vm._v(" This content is in card body component. ")])],2),_c('p',[_vm._t("description",[_c('small',[_vm._v(_vm._s(_vm.description))])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }